import { useTranslation } from 'react-i18next';
function Money({ status }) {
  const { t } = useTranslation('report');
  return (
    <div
      className={
        status === 0
          ? 'bg-[#ffab00] flex items-center justify-center w-[90px] h-7 mobile:h-6 mobile:w-[70px] mobile:text-[12px]  rounded-md text-white'
          : status === 1
            ? 'bg-[#00d25b] flex items-center justify-center w-[90px] h-7 mobile:h-6 mobile:w-[70px] mobile:text-[12px]  rounded-md text-white'
            : 'bg-[#fc424a] flex items-center justify-center w-[90px] h-7 mobile:h-6 mobile:w-[70px] mobile:text-[12px]  rounded-md text-white'
      }>
      <p>{status === 0 ? t('choxuly') : status === 1 ? t('thanhcong') : t('thatbai')}</p>
    </div>
  );
}

export default Money;
